<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TennisMatchSummary',
  computed: {
    data() {
      return this.update.Data;
    },
    sets() {
      return this.update.Data.Match.Sets.sort(
        (a: { SetNumber: number }, b: { SetNumber: number }) => {
          if (a.SetNumber > b.SetNumber) return 1;
          if (a.SetNumber < b.SetNumber) return -1;
          if (a.SetNumber < b.SetNumber) return 0;
        }
      );
    },
    teams() {
      return this.fixture.Name.split(' v ');
    },
  },
  props: ['update', 'fixture'],
});
</script>

<template>
  <section v-if="update">
    <div
      :class="{
        'grid grid-flow-col grid-rows-[max-content_1fr_1fr] w-max': true,
        '[grid-template-columns:repeat(auto-fit,max-content)]': true,
        'text-center border-gray-500': true,
        'custom-cells m-auto my-2': true,
      }"
    >
      <div class="h">Матч идет</div>
      <div class="b text-lg row-span-2 place-content-center">
        <i class="pi pi-check text-green-500 text-lg" v-if="!data.Match.IsMatchComplete" />
        <i class="pi pi-times text-red-500 text-lg" v-else />
      </div>

      <div class="h">Фаза</div>
      <div class="b text-lg row-span-2 place-content-center">{{ data.StateOfPlay }}</div>

      <div class="!text-left h">Игроки</div>
      <div class="text-gray-500 !text-left">{{ teams[0] }}</div>
      <div class="b text-gray-500 !text-left">{{ teams[1] }}</div>

      <template v-for="one in sets">
        <div class="h">
          С{{ one.SetNumber }}
          <i class="pi pi-stopwatch text-green-500 text-sm" v-if="!one.IsSetComplete" />
          <br />
          <span class="text-xs text-gray-500">{{ one.SetType }}</span>
        </div>
        <div>{{ one.SetScore.CompetitorOneScore }}</div>
        <div class="b">{{ one.SetScore.CompetitorTwoScore }}</div>

        <template v-if="one.Games" v-for="game in one.Games">
          <div class="h">
            Г{{ game.GameNumber }}
            <br />
            <span class="text-xs text-gray-500">{{ game.GameType }}</span>
          </div>
          <div>{{ game.GameScore.DisplayCompetitorOneScore }}</div>
          <div class="b">{{ game.GameScore.DisplayCompetitorTwoScore }}</div>

          <template v-if="game.Points" v-for="point in game.Points">
            <div class="h">П{{ point.PointNumber }}<br/>&nbsp;</div>
            <div>
              <i class="pi pi-circle-fill text-xs text-yellow-200" v-if="point.Server.CompetitorId === 'A'" />
            </div>
            <div class="b">
              <i class="pi pi-circle-fill text-xs text-yellow-200" v-if="point.Server.CompetitorId === 'B'" />
            </div>
          </template>
        </template>
      </template>

      <div class="r h">Счет матча</div>
      <div class="r font-mono text-lg">{{ data.Match.MatchScore.CompetitorOneScore }}</div>
      <div class="r b font-mono text-lg">{{ data.Match.MatchScore.CompetitorTwoScore }}</div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.custom-cells {
  & > div {
    @apply px-3 pt-2 pb-1 text-lg;
    @apply border border-gray-500;

    &:not(.r) {
      @apply border-r-0;
    }

    &:not(.b) {
      @apply border-b-0;
    }

    &.h {
      @apply bg-gray-300 dark:bg-gray-700 place-content-center;
    }
  }
}
</style>
